import { recipe } from "@vanilla-extract/recipes";
import { style } from "@vanilla-extract/css";
import { rem } from "@huub-web/utils/css/rem";

import { transition } from "../../utils/transition";
import { disabledState } from "../../theme/disabledState";
import { typographyDefinition } from "../../theme";
import { responsiveCard } from "../../utils/responsive";

import { theme } from "../../theme/css/theme.css";

export const containerStyle = recipe({
  base: {
    gap: theme.spacings.s,
    width: "100%",
    paddingBottom: rem(1), // To accommodate for the active state offset
  },
  variants: {
    wrapper: {
      grid: {
        display: "grid",
        overflow: "hidden",
      },
      carousel: {
        display: "flex",
        overflowX: "auto",
        scrollSnapType: "x mandatory",
        paddingBottom: theme.spacings.xs,
        selectors: {
          "&::-webkit-scrollbar": {
            height: rem(2),
          },
          "&::-webkit-scrollbar-track": {
            background: "transparent",
          },
          "&::-webkit-scrollbar-thumb": {
            background: theme.colors.defaultBorder,
            borderRadius: rem(2),
          },
          "&::-webkit-scrollbar-thumb:hover": {
            background: theme.colors.defaultBorderHover,
          },
        },
      },
    },
    variant: {
      default: {
        gridTemplateColumns: "repeat(3, 1fr)",
      },
      twoColumn: {
        gridTemplateColumns: "repeat(2, 1fr)",
      },
    },
  },
});

export const leadingStyle = recipe({
  base: {
    transition: transition("all"),
    filter: "grayscale(100%) brightness(125%)",
  },
  variants: {
    checked: {
      true: {
        selectors: {
          '&:not([data-disabled="true"])': {
            filter: "grayscale(0%) brightness(100%)",
          },
        },
      },
    },
    hover: {
      true: {
        selectors: {
          '&:not([data-disabled="true"])': {
            filter: "grayscale(0%) brightness(100%)",
          },
        },
      },
    },
  },
});

export const radioCardStyle = style({
  // Keep
});

export const radioCardOptionStyle = recipe({
  base: {
    //
  },
  variants: {
    wrapper: {
      grid: {
        //
      },
      carousel: {
        //
      },
    },
  },
});

export const cardContainerStyle = recipe({
  base: {
    flexShrink: 0,
    flexGrow: 0,
    position: "relative",
    cursor: "pointer",
    transition: transition("border-color", "box-shadow"),
  },
  variants: {
    checked: {
      true: {
        // Visual indication handled by border prop on Card
      },
      false: {},
    },
    disabled: {
      true: {
        ...disabledState,
        cursor: "not-allowed",
      },
    },
  },
});

export const cardInnerStyle = recipe({
  base: {},
  variants: {
    error: {
      true: {
        borderColor: `${theme.colors.error} !important`,
      },
    },
    success: {
      true: {
        borderColor: `${theme.colors.success} !important`,
      },
    },
    highlight: {
      true: {
        borderColor: `${theme.colors.warning} !important`,
      },
    },
  },
});

export const cardInputStyle = style({
  opacity: 0,
  position: "absolute",
  top: 0,
  left: 0,
  width: "100%",
  height: "100%",
  margin: 0,
  cursor: "pointer",
  zIndex: 1,
  selectors: {
    "&:disabled": {
      cursor: "not-allowed",
    },
    "&:focus-visible": {
      outline: "none",
    },
  },
});

export const labelStyle = style({
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  ...(typographyDefinition.bodyS as any),
  ...responsiveCard({
    200: {
      ...typographyDefinition.bodyM,
    },
  }),
});
